// src/components/widget/players/ClonedVideoPlayer.tsx
//
// Affiche en plein écran (ou dans n'importe quel conteneur) le même flux
// que MonitorVideoPlayer, sans ouvrir un second flux HLS réseau et sans
// captureStream().
// Reçoit le MediaStream directement depuis useMonitorStream via prop.

import React, { useEffect, useRef } from 'react';

interface ClonedVideoPlayerProps {
  /** MediaStream issu de useMonitorStream — assigné directement à srcObject. */
  mediaStream : MediaStream | null;
  style?      : React.CSSProperties;
}

export const ClonedVideoPlayer: React.FC<ClonedVideoPlayerProps> = ({
  mediaStream,
  style,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (!mediaStream) {
      video.srcObject = null;
      return;
    }

    if (video.srcObject !== mediaStream) {
      video.srcObject = mediaStream;
      video.play().catch(() => {});
    }

    return () => {
      video.pause();
      video.srcObject = null;
    };
  }, [mediaStream]);

  const defaultStyle: React.CSSProperties = {
    width     : '100%',
    height    : '100%',
    objectFit : 'contain',
    background: '#000',
  };

  return (
    <video
      ref        = {videoRef}
      autoPlay
      playsInline
      muted
      style      = {{ ...defaultStyle, ...style }}
    />
  );
};

export default ClonedVideoPlayer;